import { Router } from "@frui.ts/screens";
import { ManualEntityValidator, attachAutomaticValidator } from "@frui.ts/validation";
import Region, { RegionValidationRules } from "entities/region";
import EnumRepository from "repositories/enumRepository";
import EventBus from "services/eventBus";
import LocalizationService from "services/localizationService";
import NotificationService from "services/notificationService";
import { Modules, newNavigationName } from "config";
import CreateViewModel from "viewModels/createViewModel";
import RegionsViewModel from "./regionsViewModel";
import { observable, reaction } from "mobx";
import { bound } from "@frui.ts/helpers";

@Router.registerRoute({ name: Router.Self, route: newNavigationName })
export default class RegionCreateViewModel extends CreateViewModel<Region> {
  readonly modelName = "region";
  private unsubscriptions: Array<() => void> = [];
  @observable private alreadyUsed: string[] = [];
  private manualValidator = new ManualEntityValidator<Region>(true);

  constructor(
    protected repository: EnumRepository,
    protected localizationService: LocalizationService,
    protected notificationService: NotificationService,
    protected eventBus: EventBus,
    protected regionsViewModel: RegionsViewModel
  ) {
    super();
    this.navigationName = newNavigationName;
  }

  async onInitialize(): Promise<void> {
    await super.onInitialize();
    this.unsubscriptions.push(reaction(() => this.item.licensePlateLetter, this.onLicensePlateLetterChange));
  }

  protected async loadDetail(): Promise<Region> {
    await this.regionsViewModel.loadData();
    const entity = new Region();
    this.alreadyUsed = this.regionsViewModel.items
      .map(region => {
        return region.licensePlateLetter;
      })
      .filter(licensePlateLetter => licensePlateLetter !== entity.licensePlateLetter);
    attachAutomaticValidator(entity, {
      ...RegionValidationRules,
      licensePlateLetter: { ...RegionValidationRules.licensePlateLetter, manualValidation: this.manualValidator },
    });
    return entity;
  }

  @bound
  private onLicensePlateLetterChange() {
    if (this.alreadyUsed.includes(this.item.licensePlateLetter)) {
      this.addAlreadyExistLicensePlateLetterError();
    } else {
      this.manualValidator.removeError("licensePlateLetter");
    }
  }

  private addAlreadyExistLicensePlateLetterError() {
    this.manualValidator.addError("licensePlateLetter", this.translate("licensePlateLetterMustBeUnique"));
  }

  protected postData() {
    return this.repository.create(this.item, "regions");
  }

  translate(code: string, size?: number | undefined): string {
    return this.localizationService.translateModule(Modules.timeCharges, `regions.${code}`, size);
  }
}
